module.exports = __webpack_public_path__ + "static/media/renovationcleaning.3db8e997.png";